"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bind = exports.useSlatePresence = exports.withPresenceLeaf = exports.PresenceLeaf = exports.SlateFacade = exports.FromSlate = void 0;
const collaborative_peritext_1 = require("@jsonjoy.com/collaborative-peritext");
const SlateFacade_1 = require("./SlateFacade");
var FromSlate_1 = require("./sync/FromSlate");
Object.defineProperty(exports, "FromSlate", { enumerable: true, get: function () { return FromSlate_1.FromSlate; } });
var SlateFacade_2 = require("./SlateFacade");
Object.defineProperty(exports, "SlateFacade", { enumerable: true, get: function () { return SlateFacade_2.SlateFacade; } });
var PresenceLeaf_1 = require("./presence/PresenceLeaf");
Object.defineProperty(exports, "PresenceLeaf", { enumerable: true, get: function () { return PresenceLeaf_1.PresenceLeaf; } });
Object.defineProperty(exports, "withPresenceLeaf", { enumerable: true, get: function () { return PresenceLeaf_1.withPresenceLeaf; } });
var useSlatePresence_1 = require("./presence/useSlatePresence");
Object.defineProperty(exports, "useSlatePresence", { enumerable: true, get: function () { return useSlatePresence_1.useSlatePresence; } });
/**
 * Convenience function that creates a {@link SlateFacade} and wires it to the
 * Peritext CRDT via {@link PeritextBinding}.
 *
 * @param peritext - A {@link PeritextRef} accessor that returns the current
 *   `PeritextApi` from your json-joy model.
 * @param editor - The Slate.js `Editor` instance (created with
 *   `withReact(createEditor())`; also works with Plate.js editors).
 * @returns An `unbind` cleanup function. Call it when the component unmounts
 *   to disconnect the editor from the CRDT.
 *
 * @example
 * ```ts
 * const unbind = bind(() => model.s.toExt(), editor);
 * // on unmount:
 * unbind();
 * ```
 */
const bind = (peritext, editor) => {
    const facade = new SlateFacade_1.SlateFacade(editor, peritext);
    return collaborative_peritext_1.PeritextBinding.bind(peritext, facade);
};
exports.bind = bind;
